import { createSelector } from 'reselect'

const selector = state => state.myOffersReducer

export const myOffersFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const myOffersLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const myOffersLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const myOffersErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const myOffersLoadsSelector = createSelector(
  [selector],
  ({ offers }) => offers
)

export const myOffersNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const myOffersSelector = createSelector(
  [selector],
  offers => offers
)
